// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var PrivateBenchmarkRequestType;
(function (PrivateBenchmarkRequestType) {
    PrivateBenchmarkRequestType["Standard"] = "Standard";
    PrivateBenchmarkRequestType["Custom"] = "Custom";
    PrivateBenchmarkRequestType["All"] = "All";
})(PrivateBenchmarkRequestType || (PrivateBenchmarkRequestType = {}));
export function PrivateBenchmarkRequestTypeFromJSON(json) {
    return json;
}
export function PrivateBenchmarkRequestTypeToJSON(value) {
    return value;
}
